import type { Nullish } from '@iheartjane/types';
import Mustache from 'mustache';

import { dedupeDispensary } from './dedupeDispensary';

export const safeMustacheRender = (
  template: string,
  variables: Record<string, unknown>
): string => {
  try {
    return Mustache.render(
      template,
      variables,
      {},
      { escape: (text: string) => text }
    );
  } catch {
    return template;
  }
};

const capitalize = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1);

export const processSeoVariables = (
  template: Nullish<string>,
  variables: Record<string, unknown>
): string => {
  if (!template) return '';

  const { category } = variables;
  const resolvedVariables =
    typeof category === 'string' && category
      ? { ...variables, category: capitalize(category) }
      : variables;

  return dedupeDispensary(safeMustacheRender(template, resolvedVariables));
};
